import { render } from "./RepositoryView.vue?vue&type=template&id=7ec0e0c0&ts=true"
import script from "./RepositoryView.vue?vue&type=script&lang=ts"
export * from "./RepositoryView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Admin/Repository/RepositoryView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7ec0e0c0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7ec0e0c0', __exports__)) {
    api.reload('7ec0e0c0', __exports__)
  }
  
  module.hot.accept("./RepositoryView.vue?vue&type=template&id=7ec0e0c0&ts=true", () => {
    api.rerender('7ec0e0c0', render)
  })

}


export default __exports__